<script lang="ts" setup>
import IoInputWrapper from '@/components/form/InputWrapper.vue';

const modelValue = defineModel<unknown>();

withDefaults(defineProps<{
  label?: string;
  options?: {
    value: unknown;
    label: string;
  }[]
}>(), {
  label: undefined,
  options: () => [],
});
</script>

<template>
  <IoInputWrapper
    v-slot:default="{ inputId }"
    :label="label"
  >
    <select
      :id="inputId"
      style="width: 100%;"
      v-model="modelValue"
    >
      <option
        v-for="(option, optionInx) in options"
        :key="`${inputId}-${optionInx}`"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </IoInputWrapper>
</template>
